import React, { Component } from "react";

import { FirebaseProducts, firebase } from "../../firebase";
import { firebaseLooper } from "../ui/misc";

import { CircularProgress } from "@material-ui/core";
import ProductCard from "../ui/ProductCard";
import Button from "@material-ui/core/Button";

import { Helmet } from "react-helmet";

class Product extends Component {
  state = {
    isLoading: true,
    SimilarProducts: [],
    product: [],
    characteristics: [],
    removedMessage: ""
  };

  componentDidMount() {
    const productId = this.props.match.params.id;
    FirebaseProducts.child(productId)
      .once("value")
      .then(snapshot => {
        const product = snapshot.val();
        let promises = [];

        promises.push(
          new Promise((resolved, reject) => {
            firebase
              .storage()
              .ref("product")
              .child(product.image)
              .getDownloadURL()
              .then(url => {
                product.url = url;
                resolved();
              });
          })
        );

        Promise.all(promises).then(() => {
          this.setState({
            product,
            isLoading: false
          });

          FirebaseProducts.orderByChild("product")
            .equalTo(product.product)
            .once("value")
            .then(snapshot => {
              const SimilarProducts = firebaseLooper(snapshot);
              let promises = [];

              for (let key in SimilarProducts) {
                promises.push(
                  new Promise((resolved, reject) => {
                    firebase
                      .storage()
                      .ref("product")
                      .child(SimilarProducts[key].image)
                      .getDownloadURL()
                      .then(url => {
                        SimilarProducts[key].url = url;
                        resolved();
                      });
                  })
                );
              }

              Promise.all(promises).then(() => {
                for (let key in SimilarProducts) {
                  if (SimilarProducts[key].id !== productId) {
                    this.setState({
                      SimilarProducts
                    });
                  }
                }

                setTimeout(() => {
                  this.setState({
                    isLoading: false
                  });
                }, 500);
              });
            });
        });
      });
  }

  handleDelete = () => {
    const productId = this.props.match.params.id;

    FirebaseProducts.child(productId)
      .remove()
      .then(() => {
        this.setState({
          removedMessage: "Удалено"
        });

        setTimeout(() => {
          this.props.history.push({
            pathname: "./Продукты"
          });
        }, 1000);
      });
  };

  handleChange = () => {
    const productId = this.props.match.params.id;
    const product = this.state.product;
    this.props.history.push({
      pathname: `/products/${productId}/edit`,
      state: { product: product }
    });
  };

  handleRefresh = () => {
    window.location.reload();
  };

  render() {
    const { user } = this.props;
    const productId = this.props.match.params.id;
    const { product, isLoading, SimilarProducts } = this.state;
    return (
      <div id="product" style={{
        backgroundColor: 'floralwhite'
      }}>
      <Helmet>
        <meta charSet="utf-8" />
        <link rel="shortcut icon" type="image/png" href="/public/Icon.png" />
        <title>Планета Рыбака - {`${product.title}`}</title>
        <link rel="canonical" href={`http://rybalka.md.com/${productId}`} />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta
          name="description"
          content="Магазин рыболовных изделий в Молдове, Кишинёв, улица Alba-Iulia 198 ger.34/1, рынок 'Дельфин'. Тут вы найдёте удилища, кутушки, снасти, прикормки, наживки, приманки, подставки, подсаки, сумки, одежда, снаряжения и другое, всё для рыбалки."
        />
        <meta
          property="og:url"
          content={`http://rybalka.md.com/${productId}`}
        />
      </Helmet>
        {product && product !== undefined ? (
          <React.Fragment>
            <div className="container">
              <div className="wrapper">
                {isLoading ? (
                  <div className="all_products_progress">
                    <CircularProgress
                      style={{
                        color: "#38726f"
                      }}
                      thickness={5}
                    />
                  </div>
                ) : (
                  <div className="item">
                    <div className="item_top">
                      <div className="product_image">
                        <img
                          src={product.url}
                          alt="product"
                          style={{
                            width: "100%"
                          }}
                        />
                      </div>

                      <div className="desription">
                        <div className="title m">{product.title}</div>
                        <div className="item_brand m">
                          <span className="bold">Фирма:</span>
                          &nbsp;&nbsp;
                          <span>{product.brand}</span>
                        </div>

                        <div className="item_model m">
                          <span className="bold">Модель:</span>
                          &nbsp;&nbsp;
                          <span>{product.model}</span>
                        </div>
                        {product.isInStore === "Да" ? (
                          <div
                            style={{
                              color: "#21cc76",
                              fontFamily: "Roboto, sans-serif",
                              margin: "10px"
                            }}
                          >
                            Есть в наличии
                          </div>
                        ) : (
                          <div
                            style={{
                              color: "red",
                              fontFamily: "Roboto, sans-serif",
                              margin: "10px"
                            }}
                          >
                            Нет в наличии
                          </div>
                        )}
                        <div className="item_desc m">
                          <p style={{
                            wordBreak: 'break-word'
                          }}>{product.desc}</p>
                        </div>

                        {user ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start"
                            }}
                          >
                            <Button
                              variant="contained"
                              color="secondary"
                              size="small"
                              className="show_button"
                              style={{
                                color: "#fff",
                                margin: "10px",
                                display: "inline-block"
                              }}
                              onClick={this.handleDelete}
                            >
                              Удалить
                            </Button>
                            <Button
                              variant="outlined"
                              color="secondary"
                              size="small"
                              className="show_button"
                              style={{
                                color: "orange",
                                margin: "10px",
                                borderColor: "orange",
                                display: "inline-block"
                              }}
                              onClick={this.handleChange}
                            >
                              Изменить
                            </Button>
                          </div>
                        ) : null}

                        {this.state.removedMessage === "Удалено" ? (
                          <div className="error_label">Продукт удалён...</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="item_bottom">
                      <div className="divider">
                        <hr className="left" />
                        <span className="item_bottom_title">
                          Характеристики
                        </span>
                        <hr className="right" />
                      </div>

                      <div className="characteristics">
                        {product.construct ? (
                          <div className="item_characteristic">
                            <span>Конструкция:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.construct}</span>
                          </div>
                        ) : null}
                        {product.material ? (
                          <div className="item_characteristic">
                            <span>Материал:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.material}</span>
                          </div>
                        ) : null}
                        {product.handle ? (
                          <div className="item_characteristic">
                            <span>Рукоять:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.handle}</span>
                          </div>
                        ) : null}
                        {product.Wobblerlengthlength ? (
                          <div className="item_characteristic">
                            <span>Длина воблера:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.Wobblerlength}</span>
                          </div>
                        ) : null}
                        {product.length ? (
                          <div className="item_characteristic">
                            <span>Длина:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.length}</span>
                          </div>
                        ) : null}
                        {product.depth ? (
                          <div className="item_characteristic">
                            <span>Глубина:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.depth}</span>
                          </div>
                        ) : null}
                        {product.height ? (
                          <div className="item_characteristic">
                            <span>Высота:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.height}</span>
                          </div>
                        ) : null}
                        {product.width ? (
                          <div className="item_characteristic">
                            <span>Ширина:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.width}</span>
                          </div>
                        ) : null}
                        {product.diameter ? (
                          <div className="item_characteristic">
                            <span>Диаметр:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.diameter}</span>
                          </div>
                        ) : null}
                        {product.handleLength ? (
                          <div className="item_characteristic">
                            <span>Длина рукояти:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.handleLength}</span>
                          </div>
                        ) : null}
                        {product.weight ? (
                          <div className="item_characteristic">
                            <span>Вес:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.weight}</span>
                          </div>
                        ) : null}
                        {product.quant ? (
                          <div className="item_characteristic">
                            <span>Количество:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.quant}</span>
                          </div>
                        ) : null}
                        {product.rings ? (
                          <div className="item_characteristic">
                            <span>Кольца:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.rings}</span>
                          </div>
                        ) : null}
                        {product.test ? (
                          <div className="item_characteristic">
                            <span>Тест удилища:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.test}</span>
                          </div>
                        ) : null}
                        {product.NumOfPockets ? (
                          <div className="item_characteristic">
                            <span>Количество карманов:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.NumOfPockets}</span>
                          </div>
                        ) : null}
                        {product.NumOfSeparations ? (
                          <div className="item_characteristic">
                            <span>Количество разьомов:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.NumOfSeparations}</span>
                          </div>
                        ) : null}
                        {product.numSpots ? (
                          <div className="item_characteristic">
                            <span>Количество мест:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.numSpots}</span>
                          </div>
                        ) : null}
                        {product.DeepeningOfWobbler ? (
                          <div className="item_characteristic">
                            <span>Заглубление воблера:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.DeepeningOfWobbler}</span>
                          </div>
                        ) : null}
                        {product.numBranches ? (
                          <div className="item_characteristic">
                            <span>Количество лунок:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.numBranches}</span>
                          </div>
                        ) : null}
                        {product.SizeOfCell ? (
                          <div className="item_characteristic">
                            <span>Размер отсека:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.SizeOfCell}</span>
                          </div>
                        ) : null}
                        {product.diameterRing ? (
                          <div className="item_characteristic">
                            <span>Диамнитр кольца:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.diameterRing}</span>
                          </div>
                        ) : null}
                        {product.DiameterOfSpool ? (
                          <div className="item_characteristic">
                            <span>Диаметр шпули:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.DiameterOfSpool}</span>
                          </div>
                        ) : null}
                        {product.numRings ? (
                          <div className="item_characteristic">
                            <span>Количество колец:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.numRings}</span>
                          </div>
                        ) : null}
                        {product.sizeAvailable ? (
                          <div className="item_characteristic">
                            <span>Размеры в наличии:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.sizeAvailable}</span>
                          </div>
                        ) : null}
                        {product.Lesoyemkost ? (
                          <div className="item_characteristic">
                            <span>Лесоемкость FC:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.Lesoyemkost}</span>
                          </div>
                        ) : null}
                        {product.friction ? (
                          <div className="item_characteristic">
                            <span>Фрикцион:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.friction}</span>
                          </div>
                        ) : null}
                        {product.gearRatio ? (
                          <div className="item_characteristic">
                            <span>Передаточное число:&nbsp;&nbsp;&nbsp;</span>
                            <span>{product.gearRatio}</span>
                          </div>
                        ) : null}
                        {product.numBearing ? (
                          <div className="item_characteristic">
                            <span>
                              Количество подшипников:&nbsp;&nbsp;&nbsp;
                            </span>
                            <span>{product.numBearing}</span>
                          </div>
                        ) : null}
                      </div>

                      <hr className="hr-divider" />
                    </div>
                  </div>
                )}
              </div>
            </div>

            {SimilarProducts.length > 0 ? (
              <React.Fragment>
                <div className="all_products_title">Похожий товар</div>

                {isLoading ? (
                  <div className="all_products_progress">
                    <CircularProgress
                      style={{
                        color: "#38726f"
                      }}
                      thickness={5}
                    />
                  </div>
                ) : (
                  <React.Fragment>
                    <div className="similar_items">
                      {SimilarProducts.map((similarProduct, i) => (
                        <React.Fragment key={i}>
                          {similarProduct.isInStore &&
                          similarProduct.id !== productId ? (
                            <ProductCard
                              image={similarProduct.url}
                              title={similarProduct.title}
                              desc={similarProduct.desc}
                              linkTo={similarProduct.id}
                              price={similarProduct.price}
                              key={similarProduct.id}
                              isInStore={similarProduct.isInStore}
                              onClick={() => this.handleRefresh()}
                            />
                          ) : null}
                        </React.Fragment>
                      ))}
                    </div>
                  </React.Fragment>
                )}
              </React.Fragment>
            ) : null}
          </React.Fragment>
        ) : (
          <div>No Such Product...</div>
        )}
      </div>
    );
  }
}

export default Product;
